import { getActiveUid, isImpersonating } from './getActiveUid';
import { clearAuthEmbeddedReturn } from './authEmbedded';
import rest from './rest';

export async function redirect(genre = '') {
  const target = getRedirect();

  if (!isValid(target)) throw Error('INVALID_REDIRECT');

  let url = target;

  const destination = new URL(target);
  if (destination.host !== location.host) {
    // Build params via URLSearchParams so values are encoded, separators are
    // correct even when the target already has a query string (e.g. invite
    // links `/?inviteId=…&role=…`), and params land in the query rather than a
    // `#fragment`.
    const activeUid = getActiveUid();

    // Tell the destination which account is active. Identity itself rides the
    // shared `.dabblewriter.com` cookie — this just selects the account.
    // dabble-writer 3.0 reads ?uid=/?impersonate= and ignores the token below.
    if (activeUid) destination.searchParams.append(isImpersonating() ? 'impersonate' : 'uid', activeUid);

    // Legacy: dabble-writer 2.x has no cookie/x-uid flow — it establishes its
    // session from this Firebase custom token via signInWithCustomToken. Mint it
    // for the active account (x-uid), so 2.x lands on the right user too.
    const result = await rest
      .post('auth/customToken')
      .header('x-uid', activeUid ?? '')
      .credentials('include')
      .send();
    destination.searchParams.append('token', result.token);

    if (genre) {
      destination.searchParams.append('genre', genre);
      destination.searchParams.append('created', '');
    }

    url = destination.toString();
  }

  if (sessionStorage.getItem('redirect')) {
    sessionStorage.removeItem('redirect');
  }

  clearAuthEmbeddedReturn();

  window.location.href = url;
}

export function getRedirect() {
  const sessionUrl = sessionStorage.getItem('redirect');
  if (sessionUrl) return sessionUrl;

  // Default: billing portal on this app (accounts), not the writer app root.
  return `${location.origin}/billing/portal`;
}

export function isValid(string: string) {
  const url = new URL(string);
  return (
    url.hostname.endsWith('dabblewriter.com') ||
    url.hostname.startsWith('localhost') ||
    url.hostname.endsWith('.local') ||
    url.hostname.endsWith('.dabble-writer.pages.dev')
  );
}
